import {
  Box,
  Button,
  Flex,
  Image,
  Input,
  Radio,
  RadioGroup,
  Text,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import elect from "../../../img/elect2.png";
import no_image from "../../../img/bookpic.jpg";
import { IAllCourse } from "../../../models/allcourse.model";
import registrationService from "../../../services/registration.service";
import Loading from "../../common/Loading";

const PaymentAmount = ({ nextPage, ...rest }: { nextPage: any }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const { course_id } = useParams();
  // const [course, setCourse] = useState<IAllCourse>();
  const [course, setCourse] = useState<any>();
  const [loading, setLoading] = useState(true);
  const [errormessage, setErrorMessage] = useState(false);
  const [value, setValue] = useState<any>("");
  const [partamount, setPartAmount] = useState<string>();

  const returningdata = location.state;
  // console.log(returningdata, "jeboooo");

  useEffect(() => {
    registrationService
      .getEachCourse(course_id)
      .then((response) => {
        if (response && returningdata) {
          // setCourse(response);
          setCourse({ ...response, course_payment: returningdata });
          console.log(response, "check for course");
          setLoading(false);
        }
      })

      .catch((err) => err);
  }, []);

  const handleChange = (amount: string) => {
    if (course?.min_deposit)
      if (parseInt(amount) < course.min_deposit) {
        setErrorMessage(true);
      } else {
        setErrorMessage(false);
        setPartAmount(amount);
      }
  };

  const next = () => {
    if (partamount) {
      localStorage.setItem("course_amount", partamount);
      nextPage();
    } else if (course) {
      // localStorage.setItem("course_amount", course.cost.toString());
      localStorage.setItem(
        "course_amount",
        course?.course_payment?.payment.amountdue.toString()
      );
      nextPage();
    }
  };

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <Box px={6} mb="50px">
          <Flex justifyContent="center" mt="60px" mb="35px">
            <Text
              mx="auto"
              color="#616161"
              fontSize="20px"
              fontWeight="700"
              textAlign={"center"}
            >
              Brief Training Program Payment Details
            </Text>
          </Flex>
          <Flex px="15px" py="15px" boxShadow="base">
            <Image
              height="80px"
              width="120px"
              src={course?.cover_image ? course?.cover_image : no_image}
            />
            <Box ml="20px">
              <Text
                fontWeight="600"
                color="#616161"
                textTransform="capitalize"
                fontSize="16px"
              >
                {course?.name.toLowerCase()}
              </Text>

              <Text fontSize="15px" fontWeight="400" color="#959595">
                {course?.description?.substring(0, 100)}...
              </Text>
            </Box>
          </Flex>
          <Box py="8px" borderRadius="8px" boxShadow="base">
            <Flex
              justifyContent="space-between"
              pt="25px"
              pb="15px"
              px="30"
              borderBottom="1px solid"
              borderColor="lightgray"
            >
              <Text>Training Cost (NGN)</Text>
              <Text>{course?.cost}</Text>
            </Flex>
            <Flex
              justifyContent="space-between"
              pt="25px"
              pb="15px"
              px="30"
              borderBottom="1px solid"
              borderColor="lightgray"
            >
              <Text>Discount (NGN)</Text>
              <Text>{course?.discount}</Text>
            </Flex>
            <Flex
              justifyContent="space-between"
              pt="25px"
              pb="15px"
              px="30"
              borderBottom="1px solid"
              borderColor="lightgray"
            >
              <Text>Allowed Minimum Installment (NGN):</Text>
              <Text>{course?.min_deposit}</Text>
            </Flex>
            <Flex
              justifyContent="space-between"
              pt="25px"
              pb="15px"
              px="30"
              borderBottom="1px solid"
              borderColor="lightgray"
            >
              <Text>Allowed Number of Installment :</Text>
              <Text>{course?.installment}</Text>
            </Flex>
            <Flex
              justifyContent="space-between"
              pt="25px"
              pb="15px"
              px="30"
              borderBottom="1px solid"
              borderColor="lightgray"
            >
              <Text>Your Cummulative Payment Count:</Text>
              {/* <Text>{course?.installment}</Text> */}
              <Text>{course?.course_payment?.installmentcount}</Text>
            </Flex>
            <Flex
              justifyContent="space-between"
              pt="25px"
              pb="15px"
              px="30"
              borderBottom="1px solid"
              borderColor="lightgray"
            >
              <Text>Your Cummulative Payments (NGN):</Text>
              {/* <Text>{course?.cost}</Text> */}
              <Text>{course?.course_payment?.payment.amountpaid}</Text>
            </Flex>
            <Flex justifyContent="space-between" pt="25px" pb="15px" px="30">
              <Text>Total Amount Owed (NGN):</Text>
              {/* <Text>{course?.cost}</Text> */}
              <Text>{course?.course_payment?.payment.amountdue}</Text>
            </Flex>
          </Box>
          <Box py="8px" borderRadius="8px" boxShadow="base">
            <RadioGroup onChange={setValue} value={value}>
              <Flex justifyContent="space-between" pt="25px" pb="15px" px="30">
                <Radio colorScheme="red" value="full-payment">
                  Pay Full
                </Radio>
                {/* <Text>{course?.cost}</Text> */}
                <Text>{course?.course_payment?.payment.amountdue}</Text>
              </Flex>
              {course && course.installment > 1 && (
                <Flex
                  justifyContent="space-between"
                  pt="25px"
                  pb="15px"
                  px="30"
                >
                  <Radio colorScheme="red" value="part-payment">
                    Pay Part
                  </Radio>
                  {value == "part-payment" && (
                    <Box width="60%">
                      <Input
                        type="number"
                        name="amount"
                        id="amout"
                        placeholder="Enter amount"
                        onChange={(e) => {
                          handleChange(e.target.value);
                        }}
                        fontSize={13}
                      />
                      {errormessage && (
                        <Text>Minimum payment is {course?.min_deposit}</Text>
                      )}
                    </Box>
                  )}
                </Flex>
              )}
            </RadioGroup>
          </Box>
          <Flex justifyContent="center" mt={6} px={6}>
            <Button
              onClick={() => next()}
              py="13px"
              px="30px"
              isDisabled={errormessage}
              type="button"
              fontSize={11}
              borderRadius={0}
              colorScheme="red"
              size="sm"
            >
              NEXT
            </Button>
          </Flex>
        </Box>
      )}
    </>
  );
};

export default PaymentAmount;
